import React, { useRef, useEffect } from "react";
import { Group } from "react-konva";
import Konva from "konva";

interface Props {
  nodes: Konva.Node[];
  x: number;
  y: number;
  opacity: number;
}

export function KonvaNodeElement(props: Props) {
  const ref = useRef(null) as any;

  useEffect(() => {
    if (ref.current) {
      ref.current.add(...props.nodes);
    }
  }, [props.nodes]);

  return <Group ref={ref} x={props.x} y={props.y} opacity={props.opacity} />;
}
